import React from 'react';
import { MARK_STYLED, MARK_LINK } from 'storyblok-rich-text-react-renderer';
import Link from './link';
import DynamicComponent from '../components/dynamicComponent';

const rteResolver = {
    markResolvers: {
        [MARK_STYLED]: (children, props) =>
            React.createElement(
                'span',
                {
                    className: props?.class || '',
                },
                children
            ),
        [MARK_LINK]: (children, props) => {
            const { linktype, href, target } = props;
            if (linktype === 'email') {
                // Email links: add `mailto:` scheme and map to <a>
                return <a href={`mailto:${href}`}>{children}</a>;
            }
            if (href.match(/^(https?:)?\/\//)) {
                // External links: map to <a>
                return <a href={href} target={target}>{children}</a>;
            }
            // Internal links: map to <Link>
            return <Link to={href}>{children}</Link>;
        }
    },
    defaultBlokResolver: (name, props) => {
        return (
            <div className="inline-component">
                <DynamicComponent blok={props} componentType={name} />
            </div>
        )
    }
}

export default rteResolver;